import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { Avatar } from '../../Avatar'
import { FloatingTooltip } from '../../Floating'

import * as styles from './EntityProfileHeaderStaticAvatar.module.css'

function EntityProfileHeaderStaticAvatar({
  Container = 'span',
  className = styles.EntityProfileHeaderStaticAvatar,
  containerProps,
  tooltip,
  ...avatarProps
}) {
  return (
    <FloatingTooltip
      content={tooltip}
      disabled={!tooltip}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <Container {...containerProps} className={className}>
        <Avatar {...avatarProps} />
      </Container>
    </FloatingTooltip>
  )
}

export default EntityProfileHeaderStaticAvatar
